import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import Button, { Size, Color } from 'lib/Button';

const SubNavigation = ({ tabsConfig }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const getActiveTab = (config, locationPathName) => {
    return config.find((val) => locationPathName.toLowerCase().includes(val.path.toLowerCase()) && val.isVisible);
  };

  const activeTab = getActiveTab(tabsConfig, location.pathname);

  return (
    <div className="flex items-center">
      {tabsConfig.map((item) => {
        return item.isVisible ? (
          <Button
            size={Size.LARGE}
            color={activeTab?.id === item.id ? Color.NAVIGATION_TAB_ACTIVE : Color.NAVIGATION_TAB}
            onClick={() => {
              navigate(item.path);
            }}
            dataTestId="sub-navigation-tab"
            key={item.id}
            label={item.name}
          />
        ) : null;
      })}
    </div>
  );
};

SubNavigation.propTypes = {
  tabsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      isVisible: PropTypes.bool,
      name: PropTypes.string,
    }),
  ).isRequired,
};

export default SubNavigation;
